module.exports = __webpack_public_path__ + "media/icons/widget-icon-2-f20ac887.png";